import { proxy } from 'valtio'

type SettlementExportStore = {
  /** PusherSubscriptions binds `settlement_export_updated` only while the export dialog is open. */
  isDialogOpen: boolean
}

const settlementExportStore = proxy<SettlementExportStore>({
  isDialogOpen: false,
})

export default settlementExportStore
